import { Component, ChangeDetectionStrategy, Input, OnChanges } from '@angular/core'

@Component({
  selector: 'flo-twitter-share-icon',
  template: `
    <a [href]="tweetWebIntentUrl" target="_blank" data-test="twitter-share">
      <div class="social-share w-100 h-100">
        <span class="d-inline-block svg-icon-lg svg-vertical-align-top icon-social-alt color-100">
          <flo-svg-icon icon="icon-social-twitter" width="1.3em"></flo-svg-icon>
        </span>
      </div>
    </a>
  `,
  styleUrls: ['./twitter-share-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TwitterShareIconComponent implements OnChanges {
  @Input() title: string
  @Input() shareableLink: string

  /**
   * Tweet Web Intent url -  can configure Tweet text, hashtags, pass a URL, and identify Twitter accounts related to the page
   * @see {@link https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/guides/web-intent}
   */
  public tweetWebIntentUrl: string

  ngOnChanges() {
    this.tweetWebIntentUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
      this.shareableLink
    )}&text=${encodeURIComponent(this.title)}`
  }
}
